import './App.css';
import Board from './components/board';

function App() {
  return (
    <div className="App">
      <Board />      
    </div>
  );
}

export default App;
